import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { RouterModule } from "@angular/router";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { NgSelectModule } from "@ng-select/ng-select";
import { translationChunksConfig } from "@spartacus/assets";
import { AuthGuard, CmsConfig, ConfigModule, I18nModule } from "@spartacus/core";
import { OutletPosition, provideOutlet } from "@spartacus/storefront";
import { SlickCarouselModule } from 'ngx-slick-carousel';
import { ReportsModule } from "../reports/reports.module";
import { NoMouseScrollModule } from "../shared/directives/no-mouse-scroll/no-mouse-scroll.module";
import { FluDashboardBannerModule } from "../shared/modules/flu-dashboard-banner/flu-dashboard-banner.module";
import { NeedAssistanceModule } from "../shared/modules/need-assistance/need-assistance.module";
import { OverviewBannerModule } from "../shared/modules/overview-banner/overview-banner.module";
import { ProductSearchModule } from "../shared/modules/product-search/product-search.module";
import { QuickOrderModule } from '../shared/modules/quick-order/quick-order.module';
import { ReceivingHoursAlertBannerComponent } from "../shared/modules/receiving-hours-alert-banner/receiving-hours-alert-banner.component";
import { RequestSupportModule } from "../shared/modules/request-support/request-support.module";
import { StatementsModule } from "../statements/statements.module";
import { AccMyAccountComponent } from "./account-overview/acc-my-account/acc-my-account.component";
import { AccNotificationComponent } from "./account-overview/acc-notification/acc-notification.component";
import { AccOverviewPlaceholderComponent } from "./account-overview/acc-overview-placeholder/acc-overview-placeholder.component";
import { AccOverviewPlaceholder1Component } from "./account-overview/acc-overview-placeholder1/acc-overview-placeholder1.component";
import { AccountOverviewComponent } from "./account-overview/account-overview.component";
import { FinancialsListComponent } from "./account-overview/financials-list/financials-list.component";
import { FluContentComponent } from "./account-overview/flu-content/flu-content.component";
import { LoaderComponent } from "./account-overview/loader/loader.component";
import { MyAccOverviewAdBannerComponent } from "./account-overview/my-acc-overview-ad-banner/my-acc-overview-ad-banner.component";
import { MyAccOverviewMarketingNbaBannerComponent } from "./account-overview/my-acc-overview-marketing-nba-banner/my-acc-overview-marketing-nba-banner.component";
import { MyAccOverviewSaveOrderBannerComponent } from "./account-overview/my-acc-overview-save-order-banner/my-acc-overview-save-order-banner.component";
import { NewsUpdatesComponent } from "./account-overview/news-updates/news-updates.component";
import { NotficationBannerComponent } from "./account-overview/notfication-banner/notfication-banner.component";
import { OrderListComponent } from "./account-overview/order-list/order-list.component";
import { FileDragNDropDirective } from "./account-overview/order-products/file-drag-drop.directive";
import { OrderProductsComponent } from "./account-overview/order-products/order-products.component";
import { UploadDetailsComponent } from "./account-overview/upload-details/upload-details.component";
import { ViewAndReorderProductsComponent } from "./account-overview/view-and-reorder-products/view-and-reorder-products.component";
import { OffersBannerComponent } from "./account-overview/offers-banner/offers-banner.component";
import { OfferNotificationComponent } from "./account-overview/offer-notification/offer-notification.component";
import { BannerObserverModule } from "../shared/directives/banner-observer/banner-observer.module";
import {
  SanofiAoProductGridBannerComponent,
  SANOFI_AO_PRODUCT_GRID_BANNER_SLOT,
} from "./account-overview/sanofi-ao-product-grid-banner/sanofi-ao-product-grid-banner.component";
import {
  SanofiAccountOverviewBannerSlot5Component,
  SANOFI_ACCOUNT_OVERVIEW_BANNER_SLOT5,
} from "./account-overview/sanofi-account-overview-banner-slot5/sanofi-account-overview-banner-slot5.component";

@NgModule({
  declarations: [AccountOverviewComponent, OrderListComponent, FinancialsListComponent, LoaderComponent, NewsUpdatesComponent, OrderProductsComponent, FluContentComponent, AccOverviewPlaceholderComponent, AccOverviewPlaceholder1Component,
    FileDragNDropDirective,
    UploadDetailsComponent,
    AccMyAccountComponent,
    AccNotificationComponent,
    MyAccOverviewMarketingNbaBannerComponent,
    MyAccOverviewSaveOrderBannerComponent,
    MyAccOverviewAdBannerComponent,
    ViewAndReorderProductsComponent,
    NotficationBannerComponent,
    OfferNotificationComponent,
    OffersBannerComponent],
  imports: [
    CommonModule,
    SanofiAoProductGridBannerComponent,
    SanofiAccountOverviewBannerSlot5Component,
    I18nModule,
    OverviewBannerModule,
    FluDashboardBannerModule,
    RouterModule,
    SlickCarouselModule,
    StatementsModule,
    QuickOrderModule,
    NgbModule,
    ProductSearchModule,
    RequestSupportModule,
    NgSelectModule,
    FormsModule,
    ReportsModule,
    NeedAssistanceModule,
    NoMouseScrollModule,
    MatProgressSpinnerModule,
    BannerObserverModule,
    ConfigModule.withConfig({
      cmsComponents: {
        AccountOverviewFinancialsComponent: {
          component: AccountOverviewComponent,
          guards: [AuthGuard],
        },
      },
    } as CmsConfig),
  ],
  exports: [LoaderComponent, OrderProductsComponent],
  providers: [
    provideOutlet({
      id: 'AccountOverviewDeliveryHoursBannerSlot',
      position: OutletPosition.REPLACE,
      component: ReceivingHoursAlertBannerComponent,
    }),
    provideOutlet({
      id: SANOFI_AO_PRODUCT_GRID_BANNER_SLOT,
      position: OutletPosition.REPLACE,
      component: SanofiAoProductGridBannerComponent,
    }),
    provideOutlet({
      id: SANOFI_ACCOUNT_OVERVIEW_BANNER_SLOT5,
      position: OutletPosition.REPLACE,
      component: SanofiAccountOverviewBannerSlot5Component,
    }),
    provideOutlet({
      id: 'AccountOverviewPlaceholderSlot',
      position: OutletPosition.REPLACE,
      component: AccOverviewPlaceholderComponent,
    }),
    provideOutlet({
      id: 'AccountOverviewPlaceholderSlot2',
      position: OutletPosition.REPLACE,
      component: AccOverviewPlaceholder1Component,
    }),
    provideOutlet({
      id: 'AccountOverviewOrdersSlot',
      position: OutletPosition.REPLACE,
      component: AccountOverviewComponent,
    }),
    provideOutlet({
      id: 'AccountOverviewFinancialsSlot',
      position: OutletPosition.REPLACE,
      component: FinancialsListComponent,
    }),
    provideOutlet({
      id: 'SanofiAccountDashboardFluReservationsCMSSlot',
      position: OutletPosition.REPLACE,
      component: FluContentComponent,
    }),
    provideOutlet({
      id: 'SanofiAccountOverrivewContenSlot',
      position: OutletPosition.AFTER,
      component: OffersBannerComponent,
    }),
  ]
},
)
export class AccountOverviewModule { }
